window.addEventListener('SITE_START', () => {
  const sections = document.querySelectorAll('.crop-section');
  if (!sections.length) return;

  const isDesktop = window.innerWidth >= 1024;
  const $stickyContainer = document.querySelector('.sticky-container');
  const $stickyNav = $stickyContainer.querySelector('.sticky-nav');
  const $navList = $stickyNav.querySelectorAll('.__item');
  const $blind = document.querySelector('.blind-layer');

  sections.forEach((sec) => setTimeout(() => init(sec)));

  // sticky nav 클릭시 아이템 활성화
  $navList.forEach((item, i) => {
    item.addEventListener('click', (e) => {
      e.preventDefault();
      $navList.forEach(($el) => $el.classList.remove('--active'));
      item.classList.add('--active');

      const hashId = item.querySelector('a').getAttribute('href');
      const trigger = ScrollTrigger.getById(hashId);
      if (!trigger) return;

      history.replaceState(null, '', hashId); // hashchange 방지

      if (lenis) {
        window.lenis.scrollTo(trigger.end);
      } else {
        gsap.to(window, { duration: 0, scrollTo: trigger.end });
      }

      gsap.to($blind, {
        opacity: 0,
        duration: 0.5,
        pointerEvents: 'none',
        onComplete: () => $blind.classList.add('--hide'),
      });
    });
  });

  // sticky container 진입 시 네비게이션 노출
  gsap.to($stickyNav, {
    scrollTrigger: {
      trigger: $stickyContainer,
      start: 'top-=10 top',
      end: 'bottom bottom',
      onEnter: () => $stickyNav.classList.add('--visible'),
      onLeaveBack: () => $stickyNav.classList.remove('--visible'),
    },
  });

  // 최초 로딩 시 hash가 존재하면 해당 섹션으로 스크롤
  if (window.location.hash) {
    let refreshTimer;
    // 이전 타이머 초기화
    clearTimeout(refreshTimer);

    // 마지막 refresh 이후 200ms 동안 새 refresh가 없으면 실행
    refreshTimer = setTimeout(() => {
      requestAnimationFrame(() => hashScroll());
    }, 500);

    ScrollTrigger.refresh();
  } else {
    gsap.to($blind, {
      opacity: 0,
      duration: 0.5,
      pointerEvents: 'none',
      onComplete: () => $blind.classList.add('--hide'),
    });
  }

  // 해시 변경 시 해당 섹션으로 스크롤 (페이지 간 이동)
  window.addEventListener('hashchange', hashScroll);

  function hashScroll() {
    const hashId = window.location.hash;
    if (!hashId) return;

    const trigger = ScrollTrigger.getById(hashId);
    if (!trigger) return;

    if (lenis) {
      lenis.start();
      window.lenis.scrollTo(trigger.end, { immediate: true });
    } else {
      gsap.to(window, { duration: 0, scrollTo: trigger.end });
    }

    $blind.classList.remove('--hide');
    gsap.set($blind, { opacity: 1, pointerEvents: 'auto' });

    gsap.to($blind, {
      delay: 0.1,
      opacity: 0,
      duration: 0.5,
      pointerEvents: 'none',
      onComplete: () => $blind.classList.add('--hide'),
    });
  }

  function init($section) {
    const $frame = $section.querySelector('.frame-box');
    const $cropBox = $section.querySelector('.crop-box');
    const $cropImg = $cropBox.querySelector('.__image img');
    const $cropText = $cropBox.querySelector('.__header');
    const $desc = $section.querySelector('.text-box-wrapper .text-box p');

    const $sliderWrapper = $section.querySelector('.__slider');
    const $sliderText = $sliderWrapper.querySelector('.__header');
    const $sliderSwiper = $sliderWrapper.querySelector('.swiper');
    const $navigator = $sliderWrapper.querySelector('.__navigator');
    const nextBtn = $sliderWrapper.querySelector('.swiper-button-next');
    const prevBtn = $sliderWrapper.querySelector('.swiper-button-prev');

    // 계산용 함수
    const getDiffY = () => $section.clientHeight - $frame.clientHeight;
    const getDiffX = () => (window.innerWidth - $frame.clientWidth) / 2;
    const getScale = () => $frame.clientWidth / window.innerWidth;
    const getTextY = () => $sliderText.getBoundingClientRect().top - $cropText.getBoundingClientRect().top;

    initCrop();
    createTimeline();

    // swiper 생성
    const swiper = new Swiper($sliderSwiper, {
      slidesPerView: 'auto',
      spaceBetween: 10,
      speed: 300,
      navigation: { nextEl: nextBtn, prevEl: prevBtn },
      observer: true,
      observeParents: true,
      breakpoints: {
        1024: {
          spaceBetween: 20,
        },
      },
      on: {
        setTranslate(swiper, transX) {
          if (transX < 0) {
            gsap.to($sliderText, { x: transX, opacity: 0, duration: 0.3, ease: 'ease' });
          } else {
            gsap.to($sliderText, { x: transX, opacity: 1, duration: 0.3, ease: 'ease' });
          }
        },
        init: (_swiper) => {
          const total = _swiper.slides.length;
          const $page = $sliderWrapper.querySelector('.page');
          if ($page) {
            $page.querySelector('.--total').innerText = total;
            $page.querySelector('.--current').innerText = _swiper.realIndex + 1;
          }
        },
        slideChange: (_swiper) => {
          const $page = $sliderWrapper.querySelector('.page');
          if ($page) $page.querySelector('.--current').innerText = _swiper.realIndex + 1;
        },
      },
    });

    /** 타임라인 생성 함수 */
    function createTimeline() {
      const sectionId = '#' + $section.dataset.id;
      const textY = getTextY();
      // const onDarkMode = () => $stickyNav.classList.add('--dark');
      // const onLightMode = () => $stickyNav.classList.remove('--dark');
      const slideInit = () => {
        if (swiper.activeIndex === 0) return;
        swiper.slideTo(0, 300);
        gsap.set($sliderText, { visibility: 'hidden', opacity: 1 });
      };

      const tl = gsap.timeline({ paused: true });

      ScrollTrigger.create({
        trigger: $section,
        start: 'top bottom',
        onLeaveBack: () => {
          tl.revert();
          slideInit();
        },
      });

      ScrollTrigger.create({
        trigger: $section,
        start: 'top top',
        end: '+=' + $section.clientHeight / 2 + 'px',
        pin: true,
        anticipatePin: isDesktop ? 0 : 1,
        id: sectionId,
        invalidateOnRefresh: true,
        onEnter: () => {
          if (tl.progress() > 0) return;
          tl.restart();
          activateSection($section);
        },
        onLeaveBack: () => {
          activatePrevSection($section);
        },
      });

      gsap.set($sliderText, { visibility: 'hidden' });
      gsap.set($sliderSwiper, { opacity: 0, xPercent: 20, pointerEvents: 'none' });
      gsap.set($navigator, { opacity: 0, pointerEvents: 'none' });

      tl.set($sliderText, { visibility: 'hidden', opacity: 1 });

      // 📌 Desktop ---------------------------------------------
      if (isDesktop) {
        tl.add('startCrop')
          .to($cropBox, { duration: 0.4, clipPath: `inset(0px 0px 0px round 0px 0px 0px 0px)` }) //
          .to($cropImg, { duration: 0.4, scale: 1, y: 0 }, '<')
          .add('endCrop');

        tl.to($cropText, { y: textY, duration: 0.4 }, 'endCrop')
          .to($sliderText, { visibility: 'visible' })
          .to($cropText, { visibility: 'hidden' }, '<')
          .to($navigator, { opacity: 1, duration: 0.4 }, 'endCrop')
          .to(
            $sliderSwiper,
            { opacity: 1, xPercent: 0, duration: 0.4, onReverseComplete: () => slideInit() },
            'endCrop'
          );
      }
      // 📌 Mobile ---------------------------------------------
      else {
        tl.add('startCrop')
          .to($cropBox, { duration: 0.5, clipPath: `inset(0px -20px 0px round 0px 0px 0px 0px)` }) //
          .to($cropImg, { duration: 0.5, scale: 1, y: 0 }, '<')
          .add('endCrop');

        tl.to($desc, { opacity: 0, duration: 0.3 }, 'startCrop')
          .to($navigator, { opacity: 1, duration: 0.5 }, 'endCrop-=0.25')
          .to(
            $sliderSwiper,
            { opacity: 1, xPercent: 0, duration: 0.5, onReverseComplete: () => slideInit() },
            'endCrop-=0.25'
          );
      }

      // slider 및 navigator 활성화
      tl.to($navigator, { pointerEvents: 'auto', duration: 0 }, 'endCrop');
      tl.to($sliderSwiper, { pointerEvents: 'auto', duration: 0 }, 'endCrop');

      // stick nav 색상 전환
      // tl.to($stickyNav, { onStart: onLightMode, onReverseComplete: onDarkMode }, 'startCrop');
      // tl.to($stickyNav, { onStart: onDarkMode, onReverseComplete: onLightMode }, 'endCrop');
    }

    /** 네비게이션 활성화 */
    const activateSection = ($section) => {
      const id = $section.dataset.id;
      $navList.forEach((item) => {
        const navId = item.querySelector('a').getAttribute('href');
        item.classList.toggle('--active', navId === `#${id}`);
      });
    };

    /** 역스크롤 시 이전 네비게이션 활성화 */
    const activatePrevSection = ($section) => {
      const id = $section.dataset.id;
      let activeIndex = Array.from(sections).findIndex((sec) => sec.dataset.id === id);
      activeIndex = Math.max(0, activeIndex - 1);
      $navList.forEach((item, i) => item.classList.toggle('--active', i === activeIndex));
    };

    /** crop 영역 계산 초기화 함수 */
    function initCrop() {
      const DIFF_Y = getDiffY();
      const DIFF_X = getDiffX();
      const SCALE = getScale();
      const reducedH = $cropImg.clientHeight * SCALE;
      const POS_Y = reducedH - $frame.clientHeight;
      const ROUND = 12;

      const FRAME_WIDTH = $frame.clientWidth;
      const EXTEND = 20 * 2; // 좌우 -20px씩 확장 → 총 40px
      const MOBILE_SCALE = SCALE * (1 + EXTEND / FRAME_WIDTH);

      gsap.set($cropBox, {
        clipPath: `inset(${DIFF_Y}px ${DIFF_X}px 0% round ${ROUND}px ${ROUND}px 0 0)`,
      });
      gsap.set($cropImg, {
        scale: isDesktop ? SCALE : MOBILE_SCALE,
        transformOrigin: 'center bottom',
        y: POS_Y + 'px',
      });

      return { DIFF_Y, DIFF_X, POS_Y, SCALE, ROUND };
    }
  }
});
